export default {
  login: {
    succeed: "login_succeed",
    failed: "login_failed",
    usernameRequired: "username_required",
    passwordRequired: "password_required",
    systemFailed: "system_error"
  },
  logout: {
    succeed: "logout_succeed",
    failed: "logout_failed"
  },
  firstTime: {
    failed: "login_failed",
    newUsernameRequired: "new_username_required",
    newPasswordRequired: "new_password_required"
  },
  security: {
    failed: "security_failed",
    securityCodeRequired: "security_code_required"
  },
  request: {
    succeed: "request_succeed",
    failed: "request_failed",
    processing: "request_processing"
  },
  session: {
    invalidToken: "invalid_token",
    // expired: "session_expired",
    // invalidSession: "invalid_session"
    expired: "sessionExpired",
    invalidSession: "invalidSession"
  },
  updatePassword: {
    succeed: "update_password_succeed",
    failed: "update_password_failed",
    passwordRequired: "password_required",
    newPasswordRequired: "new_password_required"
  },
  getGameTypeLookup: {
    succeed: "get_game_lookup_succeed",
    failed: "get_game_lookup_failed"
  },
  getLeagueLookup: {
    succeed: "get_league_lookup_succeed",
    failed: "get_league_lookup_failed",
    dateRequired: "working_date_required",
    gameTypeRequired: "game_type_required"
  },
  getMatchResult: {
    succeed: "get_match_result_succeed",
    failed: "get_match_result_failed",
    dateRequired: "working_date_required",
    gameTypeRequired: "game_type_required",
    leagueIDRequired: "league_id_required"
  },
  unblockProfile: {
    succeed: "unblock_profile_succeed",
    failed: "unblock_profile_failed",
    memberIDRequired: "member_id_required"
  },
  resetPassword: {
    succeed: "reset_password_succeed",
    failed: "reset_password_failed",
    accountIDRequired: "account_id_required",
    newPasswordRequired: "new_password_required"
  },
  getAccountList: {
    succeed: "get_account_list_succeed",
    failed: "get_account_list_failed",
    accountIDRequired: "account_id_required"
  },
  getMemberList: {
    succeed: "get_member_list_succeed",
    failed: "get_member_list_failed",
    accountIDRequired: "account_id_required"
  },
  updateStatus: {
    succeed: "update_status_succeed",
    failed: "update_status_failed",
    accountIDRequired: "account_id_required",
    statusRequired: "status_required"
  },
  getAccountDetails: {
    succeed: "get_account_details_succeed",
    failed: "get_account_details_failed",
    accountIDRequired: "account_id_required"
  },
  addAccount: {
    succeed: "edit_account_succeed",
    failed: "edit_account_failed",
    loginIDRequired: "login_id_required",
    passwordRequired: "password_required",
    targetAccountIdContainReservedWord: "targetAccountIdContainReservedWord"
  },
  updateAuthority: {
    succeed: "update_authority_succeed",
    failed: "update_authority_failed",
    authorityOptionRequired: "authorityOptionRequired"
  },
  subAccountBlock: {
    succeed: "block_sub_account_succeed",
    failed: "block_sub_account_failed",
    loginIDRequired: "login_id_required"
  },
  subAccountUnblock: {
    succeed: "unblock_sub_account_succeed",
    failed: "unblock_sub_account_failed",
    loginIDRequired: "login_id_required"
  },
  getSettlementHistory: {
    succeed: "get_settlement_history_succeed",
    failed: "get_settlement_history_failed",
    accountIDRequired: "account_id_required"
  },
  getBetlist: {
    succeed: "get_betlist_succeed",
    failed: "get_betlist_failed",
    accountIDRequired: "account_id_required",
    betTypeRequired: "bet_type_required",
    searchIDRequired: "search_id_required",
    matchIDRequired: "match_id_required",
    isLiveRequired: "is_live_required",
    homeRunningScoreRequired: "home_running_score_required",
    awayRunningScoreRequired: "away_running_score_required"
  },
  getParlayDetail: {
    succeed: "get_parlay_detail_succeed",
    failed: "get_parlay_detail_failed",
    betIDRequired: "bet_id_required"
  },
  getBetLimit: {
    succeed: "get_bl_succeed",
    failed: "get_bl_failed",
    accountIDRequired: "account_id_required"
  },
  getDefaultBetLimit: {
    succeed: "get_bl_succeed",
    failed: "get_bl_failed",
    accountIDRequired: "account_id_required"
  },
  getCommission: {
    succeed: "get_cm_succeed",
    failed: "get_cm_failed",
    accountIDRequired: "account_id_required"
  },
  getPositionTaking: {
    succeed: "get_pt_succeed",
    failed: "get_pt_failed",
    accountIDRequired: "account_id_required"
  },
  checkDownline: {
    succeed: "check_downline_succeed",
    failed: "check_downline_failed",
    accountIDRequired: "account_id_required"
  },
  getDailyStatement: {
    succeed: "get_daily_statement_succeed",
    failed: "get_daily_statement_failed",
    accountIDRequired: "account_id_required"
  },
  getDailyWinlose: {
    succeed: "get_daily_winlose_succeed",
    failed: "get_daily_winlose_failed",
    accountIDRequired: "account_id_required"
  },
  getPlatform: {
    succeed: "get_platform_succeed",
    failed: "get_platform_failed",
    accountIDRequired: "account_id_required"
  },
  getGameResult: {
    succeed: "get_game_result_succeed",
    failed: "get_game_result_failed",
    accountIDRequired: "account_id_required",
    memberIDRequired: "member_id_required"
  },
  getPendingMatches: {
    succeed: "get_pending_matches_succeed",
    failed: "get_pending_matches_failed",
    accountIDRequired: "account_id_required"
  },
  getKeyList: {
    succeed: "get_key_list_succeed",
    failed: "get_key_list_failed"
  },
  addKey: {
    succeed: "insert_key_succeed",
    failed: "insert_key_failed"
  },
  updateKey: {
    succeed: "update_key_succeed",
    failed: "update_key_failed"
  },
  updatePositionTakingSB1: {
    succeed: "update_position_taking_sb1_succeed",
    failed: "update_position_taking_sb1_failed",
    memberIDRequired: "member_id_required"
  },
  updatePositionTakingMMO: {
    succeed: "update_position_taking_mmo_succeed",
    failed: "update_position_taking_mmo_failed",
    memberIDRequired: "member_id_required"
  },
  updatePositionTakingSL: {
    succeed: "update_position_taking_sl_succeed",
    failed: "update_position_taking_sl_failed",
    memberIDRequired: "member_id_required"
  },
  updatePositionTakingLC: {
    succeed: "update_position_taking_lc_succeed",
    failed: "update_position_taking_lc_failed",
    memberIDRequired: "member_id_required"
  },
  updateCommissionSB: {
    succeed: "update_commission_sb_succeed",
    failed: "update_commission_sb_failed",
    memberIDRequired: "member_id_required"
  },
  updateCommissionMMO: {
    succeed: "update_commission_mmo_succeed",
    failed: "update_commission_mmo_failed",
    memberIDRequired: "member_id_required"
  },
  updateCommissionSL: {
    succeed: "update_commission_sl_succeed",
    failed: "update_commission_sl_failed",
    memberIDRequired: "member_id_required"
  },
  updateCommissionLC: {
    succeed: "update_commission_lc_succeed",
    failed: "update_commission_lc_failed",
    memberIDRequired: "member_id_required"
  },
  updateBetLimitSB: {
    succeed: "update_bet_limit_sb_succeed",
    failed: "update_bet_limit_sb_failed",
    memberIDRequired: "member_id_required"
  },
  updateBetLimitLC: {
    succeed: "update_bet_limit_lc_succeed",
    failed: "update_bet_limit_lc_failed",
    memberIDRequired: "member_id_required"
  },
  updateAccountDetails: {
    succeed: "update_account_details_succeed",
    failed: "update_account_details_failed",
    memberIDRequired: "member_id_required"
  },
  resetWin: {
    succeed: "reset_accumulate_win_succeed",
    failed: "reset_accumulate_win_failed",
    accountIDRequired: "account_id_required"
  },
  cashDeposit: {
    succeed: "cash_deposit_succeed",
    failed: "cash_deposit_failed",
    accountIDRequired: "account_id_required"
  },
  cashWithdrawal: {
    succeed: "cash_withdrawal_succeed",
    failed: "cash_withdrawal_failed",
    accountIDRequired: "account_id_required"
  },
  getDashboardInfo: {
    succeed: "get_dashboard_info_succeed",
    failed: "get_dashboard_info_failed",
    accountIDRequired: "account_id_required"
  },
  getSportTypeWinlose: {
    succeed: "get_sport_type_winlose_succeed",
    failed: "get_sport_type_winlose_failed",
    accountIDRequired: "account_id_required",
    searchIDRequired: "search_id_required"
  },
  updatePositionTakingMMO: {
    succeed: "update_position_taking_mmo_succeed",
    failed: "update_position_taking_mmo_failed",
    accountIDRequired: "account_id_required"
  },
  getLog: {
    urlRequired: "url_required",
    targetIDRequired: "target_id_required"
  },
  message: {
    succeed: "getMessageSucceed",
    failed: "getMessageFailed",
    startDateRequired: "startDateRequired",
    endDateRequired: "endDateRequired",
    anTypeRequired: "anTypeRequired"
  },
  getSystemParlay: {
    succeed: "get_system_parlay_succeed",
    failed: "get_system_parlay_failed",
    accountIDRequired: "account_id_required"
  },
  getSchedule: {
    succeed: "get_schedule_succeed",
    failed: "get_schedule_failed",
    accountIDRequired: "account_id_required"
  },
  getPlatformWinlose: {
    succeed: "get_platform_winlose_succeed",
    failed: "get_platform_winlose_failed",
    accountIDRequired: "account_id_required",
    searchIDRequired: "search_id_required"
  },
  getWallet: {
    succeed: "get_wallet_succeed",
    failed: "get_wallet_failed",
    accountIDRequired: "account_id_required",
    accountTypeRequired: "account_type_required"
  },
  checkDirectDownline: {
    succeed: "check_downline_succeed",
    failed: "check_downline_failed",
    accountIDRequired: "account_id_required"
  },
  getSettlementList: {
    succeed: "get_settlement_list_succeed",
    failed: "get_settlement_list_failed",
    accountIDRequired: "account_id_required"
  },
  settlement: {
    succeed: "settlement_succeed",
    failed: "settlement_failed",
    accountIDRequired: "account_id_required",
    settleAmountRequired: "settle_amount_required"
  },
  addAdmin: {
    succeed: "edit_account_succeed",
    failed: "edit_account_failed",
    memberIDRequired: "member_id_required",
    passwordRequired: "password_required"
  },
  getCurrency: {
    succeed: "get_platform_succeed",
    failed: "get_platform_failed",
    // accountIDRequired: "account_id_required"
  },
  getTicketList: {
    succeed: "get_ticket_list_succeed",
    failed: "get_ticket_list_failed",
    memberIDRequired: "member_id_required"
  },
  ticketProcess: {
    succeed: "process_ticket_succeed",
    failed: "process_ticket_failed",
    ticketIDRequired: "ticket_id_required"
  },
  updatePromoStatus: {
    succeed: "update_status_succeed",
    failed: "update_status_failed",
    promotionIDRequired: "promotion_id_required",
    statusRequired: "status_required"
  },
  getNekoResult: {
    succeed: "get_neko_result_succeed",
    failed: "get_neko_result_failed",
    accountIdRequired: "account_id_required",
    resultIdRequired: "result_id_required"
  },
  getDomainInfo: {
    succeed: "get_domain_info_succeed",
    failed: "get_domain_info_failed"
  },
  getBankAccount: {
    succeed: "get_bank_account_succeed",
    failed: "get_bank_account_failed",
    accountIDRequired: "account_id_required"
  },
  upsertBankAccount: {
    succeed: "update_bank_account_succeed",
    failed: "update_bank_account_failed",
    accountIDRequired: "account_id_required"
  },
  getAccountSocial: {
    succeed: "get_social_account_succeed",
    failed: "get_social_account_failed",
    accountIDRequired: "account_id_required"
  },
  upsertAccountSocial: {
    succeed: "update_social_account_succeed",
    failed: "update_social_account_failed",
    accountIDRequired: "account_id_required"
  },
};
